module.exports = __webpack_public_path__ + "static/media/Calibri.08fd5b7b.woff2";